import styled from 'styled-components';

import { FontSizeTypes } from '@folx-types/theme';

// import theme from '@theme/FolxTheme';
import theme from '@theme/WsTheme';

type IHeaderProps = {
	level: '1' | '2' | '3' | '4' | '5' | '6';
	color?: 'black' | 'white' | 'cyan';
	variant?: 'bold' | 'normal' | 'lite';
};

const levelMap: { [key: string]: FontSizeTypes } = {
	'1': 'xxl',
	'2': 'xl',
	'3': 'lg',
	'4': 'md',
	'5': 'sm',
	'6': 'xs',
};

const Header = styled.span<IHeaderProps>`
	font-family: ${({ level, variant = 'normal' }) => {
		if (level === '6' || variant === 'bold') return 'Chalet-NewYorkSixty, sans-serif';
		if (level === '1') return 'Hatton';
		return 'Chalet-LondonSixty, sans-serif';
	}};
	font-size: ${({ level }) => theme.fontSizes.headerMobile[levelMap[level]]};
	line-height: ${({ level }) => theme.lineHeights.header[levelMap[level]]};
	${({ variant }) => variant === 'lite' && 'font-weight: 200;'}
	color: ${({ color }) => color || 'black'};
	@media ${theme.responsive.breakpoints.laptop} {
		font-size: ${({ level }) => theme.fontSizes.header[levelMap[level]]};
	}
`;

export default Header;
